import type { ReactNode } from "react";

import * as styles from "./feedback.scss";

interface FeedbackProps {
	children?: ReactNode;
}

export const Feedback = ({ children }: FeedbackProps) => {
	return <div className={styles.feedback}>{children}</div>;
};
